export function getDecimalSeparator(locale: string): string {
  return (
    Intl.NumberFormat(locale)
      .formatToParts(1.1)
      .find((part) => part.type === 'decimal')?.value || '.'
  );
}
